// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app__modules_study_study_module_ts":"65c0fa9fa9db92f5","src_app__modules_dashboard_dashboard_module_ts":"2491dccf2fd1ca76"}[chunkId] + ".js";
};